import { Dialog, FlatButton, Paper } from 'material-ui';
import * as Parse from 'parse';
import * as React from 'react';
import { FileModel, MetaImage, StringModel } from '../../../../models';
import { Views } from '../../../abstract';
import './../Styles/AddEditViewStyle.css';
import MultilanguageTopBarView from './MultilanguageAddEditTopBarView';

export interface IAddEditViewProps extends Interfaces.IViewProps {
    onBack?: () => void
    onSave: () => void
    isNextStepAfterCreationDialogOpen?: boolean
    onAnotherCreation?: () => void
}

export interface IAddEditViewState extends Interfaces.IViewState {
    languageTabValue: string
}

class DashboardPostsAddEditView<P, S> extends Views.View<P & IAddEditViewProps, S & IAddEditViewState> {

    constructor(props: any) {
        super(props);
        const defaultState: any = {
            drawerState: false,
            languageTabValue: 'ru',
            model: this.props.model,
            content: { ru: '', en: '' },
            error: ''
        }
        this.state = defaultState;
    }

    public componentWillReceiveProps(nextProps: IAddEditViewProps) {
        this.setState({ model: nextProps.model, snackbarText: nextProps['snackbarText'] ? nextProps['snackbarText'] : '' });
    }


    public onDropImage(files?: any, name?: string, isArray = false) {
        const { model, languageTabValue } = this.state;
        name = name ? name : 'image';
        if (isArray) {
            files = files.map((f: File) => {
                const newFile = new FileModel();
                const pFile = new Parse.File(f.name, f);
                newFile[languageTabValue as any] = pFile;
                model[name!].push(newFile);
            })
        } else if (name.split(' ').length === 2) {
            const names = name.split(' ');
            if (model[names[0]]) {
                model[names[0]][names[1]] = files ? new Parse.File(files[0]['name'], files[0], files[0]['type']) : null;
            } else {
                model[names[0]] = new MetaImage()
                model[names[0]][names[1]] = files ? new Parse.File(files[0]['name'], files[0], files[0]['type']) : null;
            }
        } else {
            model[name][languageTabValue] = files ? new Parse.File(files[0]['name'], files[0], files[0]['type']) : null;
        }
        this.setState({ model });
        this.clearErrorLabel();
    }

    public onTextChange(e: any, n?: string, index?: number, isNML: boolean = false) {
        const name = n || e.target.name;
        const { model, languageTabValue } = this.state;
        const value = e.target ? e.target.value : e;
        const splitedName = name.split(' ');
        const el = !n ? document.getElementsByName(e.target.name)[0] : null;
        const isMultilanguage = (el && el.getAttribute('data-field-type')) || isNML ? false : true;
        const dataType = el ? el.getAttribute('data-type') : null;
        if (isMultilanguage) {
            if (splitedName.length === 2 && index === undefined) {
                model[splitedName[0]][splitedName[1]][languageTabValue] = value;
            } else if (index! >= 0) {
                model[splitedName[0]][index!][splitedName[1]][languageTabValue] = value;
            } else {
                if (!model[name]) {
                    model[name] = new StringModel()

                }
                model[name][languageTabValue] = value;
            }
        } else {
            // tslint:disable-next-line:variable-name
            if (index! >= 0) {
                model[splitedName[0]][index!][splitedName[1]] = value;
            } else if (dataType !== 'number' || (dataType === 'number' && Number(value)) || value === '') {
                model[name] = value;
            }
        }
        this.setState({ model });
        this.clearErrorLabel();
    }

    public onLanguageChange(v: string) {
        this.setState({ languageTabValue: v }  as any)
    }

    public validateForm() {
        // ...
    }

    public renderLeftSide(): JSX.Element | any {
        return null
    }

    public renderRightSide(): JSX.Element | any {
        return null
    }

    public renderFullWidthSide(): JSX.Element | any {
        return null
    }

    public render(): JSX.Element {
        const { onBack, isNextStepAfterCreationDialogOpen, onAnotherCreation, onDialogClose, accessAvailable } = this.props;
        const { languageTabValue } = this.state;
        return (
            <Paper className="add-edit-container">
                {this.loadingView()}
                {accessAvailable ?
                    <React.Fragment>
                        <MultilanguageTopBarView
                            className="top-bar"
                            onBack={onBack ? () => onBack() : null}
                            onSave={() => this.validateForm()}
                            onLanguageChange={(v: string) => this.onLanguageChange(v)}
                            languageTabValue={languageTabValue}

                        />
                        {this.errorLabel()}
                        <div className="content">
                            {this.renderLeftSide() ?
                                <div className="side left">
                                    {this.renderLeftSide()}
                                </div>
                                : null}
                            {this.renderRightSide() ?
                                <div className="side right">
                                    {this.renderRightSide()}
                                </div>
                                : null}
                            {this.renderFullWidthSide() ?
                                <div className="side full">
                                    {this.renderFullWidthSide()}
                                </div> : null}
                        </div>
                        {this.errorLabel()}
                        <MultilanguageTopBarView
                            className="bottom-bar"
                            onBack={onBack ? () => onBack() : null}
                            onSave={() => this.validateForm()}
                            onLanguageChange={(v: string) => this.onLanguageChange(v)}
                            languageTabValue={languageTabValue}

                        />
                    </React.Fragment> : 'В доступе отказано!'}
                <Dialog
                    open={((isNextStepAfterCreationDialogOpen !== undefined && isNextStepAfterCreationDialogOpen !== null) ? isNextStepAfterCreationDialogOpen! : false) as any}
                    title="Что делаем дальше?"
                    actions={[
                        <FlatButton onClick={onAnotherCreation} key="1" label="Создать новый объект" />,
                        <FlatButton onClick={onBack} key="2" label="Вернуться назад" />,
                        <FlatButton onClick={onDialogClose} key="3" label="Закрыть" />
                    ]}
                />
            </Paper>
        );
    }
}

export default DashboardPostsAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/abstract/Views/CommonView.tsx